import React from "react";
import { Navigate } from "react-router-dom";

const AccountReceivableListComponent = React.lazy(
  () =>
    import("../../../../../components/account-receivable/components/list/page"),
);
const AccountReceivableAddComponent = React.lazy(
  () =>
    import("../../../../../components/account-receivable/components/add/page"),
);

export const accountReceivableRoutes = [
  {
    path: "add",
    element: <AccountReceivableAddComponent />,
  },
  {
    path: "list",
    element: <AccountReceivableListComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/finanzas/account-receivable/list" />,
  },
];
